<template>
    <div id="app">
        <section id="team" class="team">
            <div class="team-decor">
                <div class="team-circle1">
                    <img :src="require('../assets/images/team1.png')" alt="" />
                </div>
                <div class="team-circle2">
                    <img :src="require('../assets/images/team3.png')" alt="" />
                </div>
                <div class="team-circle3">
                    <img :src="require('../assets/images/team.png')" alt="" />
                </div>
            </div>
            <div class="container">
                <div class="row ">
                    <div class="col-sm-12">
                        <h2 class="title">our <span>smart team</span></h2>
                    </div>
                    <div class="col-sm-12">
                        <div>
                            <carousel
                                :className="'team-carousel'"
                                :loop="true"
                                :margin="30"
                                :items="3"
                                :nav="false"
                                :dots="true"
                                :dotsEach="true"
                                :autoplay="true"
                                :responsive="{
                                    0: { items: 1, margin: 5 },
                                    600: { items: 1, margin: 5 },
                                    768: { items: 2 },
                                    992: { items: 3 },
                                    1000: { items: 3 },
                                }"
                            >
                                <div class="team-item">
                                    <div class="team-block">
                                        <div class="team-box">
                                            <div class="team-avtar">
                                                <img :src="require('../assets/images/avtar/pc.png')" alt="" />
                                            </div>
                                            <div class="team-text">
                                                <h3>Paul Chambers</h3>
                                                <h6>Cheif Executive<br />Organiser</h6>
                                            </div>
                                            <div class="overlay">
                                                <ul class="team-social">
                                                    <li>
                                                        <a href="https://www.linkedin.com/in/paul-chambers-31267027/"><i class="fa fa-linkedin" aria-hidden="true"></i></a>
                                                    </li>
                                                    <li>
                                                        <a href="https://twitter.com/CSP_Chambers"><i class="fa fa-twitter" aria-hidden="true"></i></a>
                                                    </li>
                                                    <!-- <li><a href="#"><i class="fa fa-facebook" aria-hidden="true"></i></a></li>
                            <li><a href="#"><i class="fa fa-google-plus" aria-hidden="true"></i></a></li>
                            <li><a href="#"><i class="fa fa-instagram" aria-hidden="true"></i></a></li>
                            <li><a href="#"><i class="fa fa-rss" aria-hidden="true"></i></a></li> -->
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="team-item">
                                    <div class="team-block">
                                        <div class="team-box">
                                            <div class="team-avtar">
                                                <img :src="require('../assets/images/avtar/ja.png')" alt="" />
                                            </div>
                                            <div class="team-text">
                                                <h3>Jacob Adams</h3>
                                                <h6>
                                                    President Of America<br /><span style="font-size:8px"><i>(AOL Xtreme Research)</i></span>
                                                </h6>
                                            </div>
                                            <div class="overlay">
                                                <ul class="team-social">
                                                    <!-- <li><a href="#"><i class="fa fa-facebook" aria-hidden="true"></i></a></li>
                            <li><a href="#"><i class="fa fa-google-plus" aria-hidden="true"></i></a></li>
                            <li><a href="#"><i class="fa fa-twitter" aria-hidden="true"></i></a></li>
                            <li><a href="#"><i class="fa fa-instagram" aria-hidden="true"></i></a></li>
                            <li><a href="#"><i class="fa fa-rss" aria-hidden="true"></i></a></li> -->
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="team-item">
                                    <div class="team-block">
                                        <div class="team-box">
                                            <div class="team-avtar">
                                                <img :src="require('../assets/images/avtar/mw.png')" alt="" />
                                            </div>
                                            <div class="team-text">
                                                <h3>Matt Warrillow</h3>
                                                <h6>Imperial<br />Googler</h6>
                                            </div>
                                            <div class="overlay">
                                                <ul class="team-social">
                                                    <!-- <li><a href="#"><i class="fa fa-facebook" aria-hidden="true"></i></a></li>
                            <li><a href="#"><i class="fa fa-google-plus" aria-hidden="true"></i></a></li>
                            <li><a href="#"><i class="fa fa-twitter" aria-hidden="true"></i></a></li>
                            <li><a href="#"><i class="fa fa-instagram" aria-hidden="true"></i></a></li>
                            <li><a href="#"><i class="fa fa-rss" aria-hidden="true"></i></a></li> -->
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="team-item">
                                    <div class="team-block">
                                        <div class="team-box">
                                            <div class="team-avtar">
                                                <img :src="require('../assets/images/avtar/nk.png')" alt="" />
                                            </div>
                                            <div class="team-text">
                                                <h3>Nick Krall</h3>
                                                <h6>Independent<br />Googler</h6>
                                            </div>
                                            <div class="overlay">
                                                <ul class="team-social">
                                                    <!-- <li><a href="#"><i class="fa fa-facebook" aria-hidden="true"></i></a></li>
                            <li><a href="#"><i class="fa fa-google-plus" aria-hidden="true"></i></a></li>
                            <li><a href="#"><i class="fa fa-twitter" aria-hidden="true"></i></a></li>
                            <li><a href="#"><i class="fa fa-instagram" aria-hidden="true"></i></a></li>
                            <li><a href="#"><i class="fa fa-rss" aria-hidden="true"></i></a></li> -->
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="team-item">
                                    <div class="team-block">
                                        <div class="team-box">
                                            <div class="team-avtar">
                                                <img :src="require('../assets/images/avtar/pr.png')" alt="" />
                                            </div>
                                            <div class="team-text">
                                                <h3>Peter Ramsey</h3>
                                                <h6>Head of<br />Colouring In</h6>
                                            </div>
                                            <div class="overlay">
                                                <ul class="team-social">
                                                    <li>
                                                        <a href="https://www.facebook.com/designflavouruk"><i class="fa fa-facebook" aria-hidden="true"></i></a>
                                                    </li>
                                                    <li>
                                                        <a href="https://twitter.com/designflavouruk"><i class="fa fa-twitter" aria-hidden="true"></i></a>
                                                    </li>
                                                    <li>
                                                        <a href="https://www.instagram.com/designflavouruk/"><i class="fa fa-instagram" aria-hidden="true"></i></a>
                                                    </li>
                                                    <li>
                                                        <a href="https://www.linkedin.com/in/peter-r-5205584/"><i class="fa fa-linkedin" aria-hidden="true"></i></a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="team-item">
                                    <div class="team-block">
                                        <div class="team-box">
                                            <div class="team-avtar">
                                                <img :src="require('../assets/images/avtar/ac.png')" alt="" />
                                            </div>
                                            <div class="team-text">
                                                <h3>Aggie Chambers</h3>
                                                <h6>Mistress of<br />Coin</h6>
                                            </div>
                                            <div class="overlay">
                                                <ul class="team-social">
                                                    <!-- <li><a href="#"><i class="fa fa-facebook" aria-hidden="true"></i></a></li>
                            <li><a href="#"><i class="fa fa-google-plus" aria-hidden="true"></i></a></li>
                            <li><a href="#"><i class="fa fa-twitter" aria-hidden="true"></i></a></li>
                            <li><a href="#"><i class="fa fa-instagram" aria-hidden="true"></i></a></li>
                            <li><a href="#"><i class="fa fa-rss" aria-hidden="true"></i></a></li> -->
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- <div class="team-item">
                  <div class="team-block">
                    <div class="team-box">
                      <div class="team-avtar">
                        <img
                          :src="require('../assets/images/avtar/mb.png')"
                          alt=""
                        />
                      </div>
                      <div class="team-text">
                        <h3>Matt Brown</h3>
                        <h6>Maker of<br />Tinnitus</h6>
                      </div>
                      <div class="overlay">
                        <ul class="team-social">
                          <li>
                            <a href="#"
                              ><i class="fa fa-facebook" aria-hidden="true"></i
                            ></a>
                          </li>
                          <li>
                            <a href="#"
                              ><i
                                class="fa fa-google-plus"
                                aria-hidden="true"
                              ></i
                            ></a>
                          </li>
                          <li>
                            <a href="#"
                              ><i class="fa fa-twitter" aria-hidden="true"></i
                            ></a>
                          </li>
                          <li>
                            <a href="#"
                              ><i class="fa fa-instagram" aria-hidden="true"></i
                            ></a>
                          </li>
                          <li>
                            <a href="#"
                              ><i class="fa fa-rss" aria-hidden="true"></i
                            ></a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div> -->

                                <div class="team-item">
                                    <div class="team-block">
                                        <div class="team-box">
                                            <div class="team-avtar">
                                                <img :src="require('../assets/images/avtar/al.png')" alt="" />
                                            </div>
                                            <div class="team-text">
                                                <h3>Alex Lloyd</h3>
                                                <h6>Squire of<br />Search</h6>
                                            </div>
                                            <div class="overlay">
                                                <ul class="team-social">
                                                    <!-- <li><a href="#"><i class="fa fa-facebook" aria-hidden="true"></i></a></li>
                            <li><a href="#"><i class="fa fa-google-plus" aria-hidden="true"></i></a></li>
                            <li><a href="#"><i class="fa fa-twitter" aria-hidden="true"></i></a></li>
                            <li><a href="#"><i class="fa fa-instagram" aria-hidden="true"></i></a></li>
                            <li><a href="#"><i class="fa fa-rss" aria-hidden="true"></i></a></li> -->
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="team-item">
                                    <div class="team-block">
                                        <div class="team-box">
                                            <div class="team-avtar">
                                                <img :src="require('../assets/images/avtar/pg.png')" alt="" />
                                            </div>
                                            <div class="team-text">
                                                <h3>Paul George</h3>
                                                <h6>Master<br />Handshaker</h6>
                                            </div>
                                            <div class="overlay">
                                                <ul class="team-social">
                                                    <!-- <li><a href="#"><i class="fa fa-facebook" aria-hidden="true"></i></a></li>
                            <li><a href="#"><i class="fa fa-google-plus" aria-hidden="true"></i></a></li>
                            <li><a href="#"><i class="fa fa-twitter" aria-hidden="true"></i></a></li>
                            <li><a href="#"><i class="fa fa-instagram" aria-hidden="true"></i></a></li>
                            <li><a href="#"><i class="fa fa-rss" aria-hidden="true"></i></a></li> -->
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="team-item">
                                    <div class="team-block">
                                        <div class="team-box">
                                            <div class="team-avtar">
                                                <img :src="require('../assets/images/avtar/jc.png')" alt="" />
                                            </div>
                                            <div class="team-text">
                                                <h3>Jon Chambers</h3>
                                                <h6>Actions and Repercussions Adviser</h6>
                                            </div>
                                            <div class="overlay">
                                                <ul class="team-social">
                                                    <!-- <li><a href="#"><i class="fa fa-facebook" aria-hidden="true"></i></a></li>
                            <li><a href="#"><i class="fa fa-google-plus" aria-hidden="true"></i></a></li>
                            <li><a href="#"><i class="fa fa-twitter" aria-hidden="true"></i></a></li>
                            <li><a href="#"><i class="fa fa-instagram" aria-hidden="true"></i></a></li>
                            <li><a href="#"><i class="fa fa-rss" aria-hidden="true"></i></a></li> -->
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </carousel>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
export default {
    name: "Team"
}
</script>



// WEBPACK FOOTER //
// src/components/team.vue